import React from "react";
import {Container} from "react-bootstrap";

import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";
import {useDefaultErrorHandler} from "../../../Hooks/ErrorHooks";

import {TrackingComponent} from "./TrackingComponent";

export const ProgramsTrackingPage = props => {
    const classNames = useClassNames('sb-programs-tracking-page');
    const makePageRequest = useMakePageRequest();
    const defaultErrorHandler = useDefaultErrorHandler();

    return <Container className={classNames}>
        <TrackingComponent
            {...props}
            MakePageRequest={makePageRequest}
            DefaultErrorHandler={defaultErrorHandler}
        />
    </Container>;
};


